export default __webpack_public_path__ + "static/media/google.fb59c469.webp";